import { useAuth } from "../../store";
import apiEndpoints from "../endpoints";
import apiClient from "../exportClient";

interface LeaveRequestPayload {
  student: number;
  teacher: number;
  start_date: string;
  end_date: string;
  grade: number;
  reason: string;
  other?: string;
  recovery_method: string;
  student_name: string;
  is_start_date: string;
  is_end_date: string;
  terms_accepted: boolean;
}

const leaveApis = (id?: any) => {
  const user_id = useAuth.getState().user.user_id;
  const role = useAuth.getState().user.role;
  return {
    getParentLeaveRequests: {
      queryKey: ["Get-list-leave-requests", user_id],
      queryFn: () => {
        return apiClient.get(apiEndpoints.leaves.parentRequestList + user_id);
      },
    },

    getStatues: {
      queryKey: ["Get-leave-status", id],
      queryFn: () => {
        if (id) {
          return apiClient.get(apiEndpoints.leaves.getLeaveStatus + id + "/");
        } else {
          return Promise.resolve();
        }
      },
    },
    getFilteredLeaves: {
      queryKey: ["getFilteredLeaves", user_id],
      queryFn: (e?: any) => {
        const userType =
          role === "Teacher"
            ? "teacher"
            : role === "Parent"
            ? "parent"
            : role === "Student"
            ? "student"
            : role === "AttandanceCoordinator"
            ? "attendace_coordinator"
            : role === "LEA_Admin"
            ? "district_admin"
            : role === "School_Admin"
            ? "school"
            : "clerk";
        if (e === "all") {
          return apiClient.get(apiEndpoints.leaves.getFilteredLeaves, {
            params: {
              [userType]: user_id,
            },
          });
        }

        if (role === "School_Admin" && e === "requests") {
          return apiClient.get(apiEndpoints.leaves.getFilteredLeaves, {
            params: {
              principal_approved: "pending",
            },
          });
        }

        if (role === "LEA_Admin" && e === "approval") {
          return apiClient.get(apiEndpoints.leaves.getFilteredLeaves, {
            params: {
              status: "LEA_Approval",
              [userType]: user_id,
              lea_approved: "pending",
            },
          });
        }

        if (role === "Parent" && e === "requests") {
          return apiClient.get(apiEndpoints.leaves.getFilteredLeaves, {
            params: {
              parent_approved: "pending",
              parent: user_id,
            },
          });
        }

        if (role === "Teacher" && e === "MF") {
          return apiClient.get(apiEndpoints.leaves.getFilteredLeaves, {
            params: {
              teacher: user_id,
              principal_suggestion: true,
            },
          });
        }

        const userBasedStatus =
          role === "Teacher"
            ? "IS_Requested"
            : role === "Parent"
            ? "ParentReview"
            : role === "Student"
            ? "StudentReview"
            : role === "AttandanceCoordinator"
            ? "AttendanceCoordinatorReview"
            : role === "LEA_Admin" && e === "requests"
            ? "LEAReview"
            : role === "LEA_Admin" && e === "approval"
            ? "LEA_Approval"
            : role === "School_Admin" && e === "requests"
            ? "PrincipalReview"
            : role === "School_Admin" && e === "approval"
            ? "Principal_Approval"
            : "clerk";
        return apiClient.get(apiEndpoints.leaves.getFilteredLeaves, {
          params: {
            status: userBasedStatus,
            [userType]: user_id,
          },
        });
      },
    },
    getTeacherLeaveRequests: {
      queryKey: ["teacher-list-leave-requests", user_id, role],
      queryFn: (teacher: any) => {
        return apiClient.get(
          role === "Teacher"
            ? apiEndpoints.leaves.teacherRequestList + user_id
            : teacher
            ? apiEndpoints.leaves.getLeaveRequestsForClerk +
              `?teacher=${teacher}`
            : apiEndpoints.leaves.getLeaveRequestsForClerk
        );
      },
    },
    getLeaveStatus: {
      staleTime: 0,
      refetchOnWindowFocus: true,
      queryKey: ["Get-leave-status", id],
      queryFn: () => {
        return apiClient.get(apiEndpoints.leaves.getStatus + id + "/");
      },
    },
    raiseLeaveRequest: {
      mk: ["Create-leave-request"],
      mf: async (values: LeaveRequestPayload) => {
        return apiClient.post(
          apiEndpoints.leaves.raiseRequest + user_id + "/",
          values
        );
      },
    },

    manualLeaveRequest: {
      mk: ["raise-manual-leave-request"],
      mf: async (values: any) => {
        return apiClient.post(
          apiEndpoints.leaves.raiseLeaveRequestManual + user_id + "/",
          values
        );
      },
    },
    updateLeaveStatus: {
      mk: ["update-leave-status", user_id, id],
      // Complex leave status update with dynamic parameter handling
      mf: ({
        signature,
        tasks,
        taskStatus,
        specialEd = false,
        actionType,
        modificationText,
      }: {
        signature?: string | undefined;
        tasks?: any[];
        taskStatus?: any;
        specialEd?: boolean;
        actionType?: "MR" | "accept" | "reject" | string;
        modificationText?: string;
        submissionDate?: string;
      }) => {
        if (role === "Teacher") {
          return Promise.resolve();
          // return apiClient.post(
          //   apiEndpoints.leaves.updateLeaveStatus + id + '/',
          //   {
          //     status: 'StudentReview',
          //     submission_date: submissionDate,
          //   }
          // );
        } else if (role === "School_Admin") {
          if (taskStatus === "Principal_Approval") {
            return apiClient.post(
              apiEndpoints.leaves.updateLeaveStatus + id + "/",
              {
                status: "LEA_Approval",
                principal_leave_signature: signature,
              }
            );
          } else {
            if (actionType === "MR") {
              return apiClient.post(
                apiEndpoints.leaves.updatePrincipalSuggestion + id + "/",
                {
                  suggestions: [
                    {
                      principal: modificationText,
                    },
                  ],
                }
              );
            } else {
              return apiClient.post(
                apiEndpoints.leaves.principalApproves + id + "/",
                {
                  principal_signature: signature,
                  principal_approved: "accepted",
                  specialeducationservices: specialEd,
                }
              );
            }
          }
        } else if (role === "Parent") {
          return apiClient.post(apiEndpoints.leaves.parentApproves + id + "/", {
            parent_signature: signature,
            parent_approved: "accepted",
          });
        } else if (role === "AttandanceCoordinator") {
          return apiClient.post(apiEndpoints.leaves.acApprove, {
            status: "LEAReview",
            coordinator_signature: signature,
            tasks: tasks,
          });
        } else if (role === "LEA_Admin") {
          if (taskStatus === "LEA_Approval") {
            return apiClient.post(
              apiEndpoints.leaves.updateLeaveStatus + id + "/",
              {
                status: "IS_Requested",
                lea_leave_signature: signature,
              }
            );
          } else {
            return apiClient.post(apiEndpoints.leaves.leaAdminApproves, {
              status: "Completed",
              lea_signature: signature,
              tasks: tasks,
            });
          }
        } else {
          return null;
        }
      },
    },
    getAdaApprovedLeaves: {
      queryKey: ["getAdaApprovedLeaves"],
      queryFn: () => {
        return apiClient.get(apiEndpoints.leaves.getAdaApprovedLeaves);
      },
    },
    downloadADAreport: {
      queryKey: ["downloadADAreport"],
      queryFn: (leaveId: any) => {
        return apiClient.get(
          apiEndpoints.leaves.downlaodADAReport + leaveId + "/"
        );
      },
    },
  };
};

export default leaveApis;
